import React, { useEffect, useState } from "react";
import axiosClient from "../api/axiosClient";

const initialForm = { name: "", slug: "" };

const Tags = () => {
    const [tags, setTags] = useState([]);
    const [loading, setLoading] = useState(true);
    const [form, setForm] = useState(initialForm);
    const [editingId, setEditingId] = useState(null);
    const [saving, setSaving] = useState(false);
    
    useEffect(() => {
        fetchTags();
    }, []);
    
    const fetchTags = async () => {
        setLoading(true);
        try {
            const res = await axiosClient.get("/tags/");
            setTags(res.data.data || []);
        } finally {
            setLoading(false);
        }
    };
    
    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };
    
    const handleAdd = async (e) => {
        e.preventDefault();
        if (!form.name || !form.slug) {
            alert("Please enter tag name and slug.");
            return;
        }
        setSaving(true);
        try {
            const res = await axiosClient.post("/tags/", form);
            setTags([...tags, res.data.data]);
            setForm(initialForm);
        } catch {
            alert("Failed to add tag.");
        } finally {
            setSaving(false);
        }
    };
    
    const startEdit = (tag) => {
        setEditingId(tag.id);
        setForm({ name: tag.name, slug: tag.slug });
    };
    
    const cancelEdit = () => {
        setEditingId(null);
        setForm(initialForm);
    };
    
    const handleUpdate = async (e) => {
        e.preventDefault();
        if (!form.name || !form.slug) {
            alert("Please enter tag name and slug.");
            return;
        }
        setSaving(true);
        try {
            const res = await axiosClient.put(`/tags/${editingId}`, form);
            setTags(tags.map((tag) => (tag.id === editingId ? res.data.data : tag)));
            cancelEdit();
        } catch {
            alert("Failed to update tag.");
        } finally {
            setSaving(false);
        }
    };
    
    const handleDelete = async (id) => {
        if (!window.confirm("Delete this tag?")) return;
        try {
            await axiosClient.delete(`/tags/${id}`);
            setTags(tags.filter((tag) => tag.id !== id));
        } catch {
            alert("Failed to delete tag.");
        }
    };
    
    return (
        <div className="container mt-4" style={{ maxWidth: "600px" }}>
            <h2 className="mb-4">Tags</h2>
            
            <div className="card mb-4">
                <div className="card-body">
                    <form className="row g-2 align-items-end" onSubmit={editingId ? handleUpdate : handleAdd}>
                        <div className="col">
                            <input
                                type="text"
                                className="form-control"
                                name="name"
                                placeholder="Tag Name"
                                value={form.name}
                                onChange={handleChange}
                                required
                                disabled={saving}
                            />
                        </div>
                        <div className="col">
                            <input
                                type="text"
                                className="form-control"
                                name="slug"
                                placeholder="Slug"
                                value={form.slug}
                                onChange={handleChange}
                                required
                                disabled={saving}
                            />
                        </div>
                        <div className="col-auto">
                            {editingId ? (
                                <>
                                    <button type="submit" className="btn btn-success btn-sm me-2" disabled={saving}>Save</button>
                                    <button type="button" className="btn btn-secondary btn-sm" onClick={cancelEdit} disabled={saving}>Cancel</button>
                                </>
                            ) : (
                                <button type="submit" className="btn btn-primary btn-sm" disabled={saving}>Add</button>
                            )}
                        </div>
                    </form>
                </div>
            </div>
            
            <div className="table-responsive">
                <table className="table table-striped align-middle">
                    <thead>
                    <tr>
                        <th>Name</th>
                        <th>Slug</th>
                        <th>Actions</th>
                    </tr>
                    </thead>
                    <tbody>
                    {tags.length === 0 ? (
                        <tr>
                            <td colSpan={3} className="text-center">No tags yet.</td>
                        </tr>
                    ) : (
                        tags.map((tag) => (
                            <tr key={tag.id}>
                                <td>{tag.name}</td>
                                <td>{tag.slug}</td>
                                <td>
                                    <button className="btn btn-sm btn-outline-primary me-2" onClick={() => startEdit(tag)}>
                                        Edit
                                    </button>
                                    <button className="btn btn-sm btn-outline-danger" onClick={() => handleDelete(tag.id)}>
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))
                    )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Tags;
